var _slicedToArray = require("/builds/client-projects/fert-demolition-motos-website/application/node_modules/@babel/runtime/helpers/slicedToArray.js").default;

!function webpackUniversalModuleDefinition(e, n) {
  "object" == typeof exports && "object" == typeof module ? module.exports = n() : "function" == typeof define && define.amd ? define([], n) : "object" == typeof exports ? exports["@wordpress/block-serialization-default-parser"] = n() : (e.wp = e.wp || {}, e.wp.blockSerializationDefaultParser = n());
}(self, function () {
  return function () {
    "use strict";

    var e = {};
    return function () {
      var n = e;
      var r, t, o, s;
      Object.defineProperty(n, "__esModule", {
        value: !0
      }), n.parse = void 0;
      var c = /<!--\s+(\/)?wp:([a-z][a-z0-9_-]*\/)?([a-z][a-z0-9_-]*)\s+({(?:(?=([^}]+|}+(?=})|(?!}\s+\/?-->)[^])*)\5|[^]*?)}\s+)?(\/)?-->/g;

      function Block(e, n, r, t, o) {
        return {
          blockName: e,
          attrs: n,
          innerBlocks: r,
          innerHTML: t,
          innerContent: o
        };
      }

      function Freeform(e) {
        return Block(null, {}, [], e, [e]);
      }

      function proceed() {
        var e = function nextToken() {
          var e = c.exec(r);
          if (null === e) return ["no-more-tokens"];

          var n = e.index,
              _e2 = _slicedToArray(e, 7),
              t = _e2[0],
              o = _e2[1],
              s = _e2[2],
              l = _e2[3],
              u = _e2[4],
              f = _e2[6],
              a = t.length,
              i = !!o,
              p = !!f,
              k = (s || "core/") + l,
              d = !!u,
              b = d ? function parseJSON(e) {
            try {
              return JSON.parse(e);
            } catch (e) {
              return null;
            }
          }(u) : {};

          if (p) return ["void-block", k, b, n, a];
          if (i) return ["block-closer", k, null, n, a];
          return ["block-opener", k, b, n, a];
        }(),
            _e = _slicedToArray(e, 5),
            n = _e[0],
            l = _e[1],
            u = _e[2],
            f = _e[3],
            a = _e[4],
            i = s.length,
            p = f > t ? t : null;

        switch (n) {
          case "no-more-tokens":
            if (0 === i) return addFreeform(), !1;
            if (1 === i) return addBlockFromStack(), !1;

            for (; 0 < s.length;) {
              addBlockFromStack();
            }

            return !1;

          case "void-block":
            return 0 === i ? (null !== p && o.push(Freeform(r.substr(p, f - p))), o.push(Block(l, u, [], "", [])), t = f + a, !0) : (addInnerBlock(Block(l, u, [], "", []), f, a), t = f + a, !0);

          case "block-opener":
            return s.push(function Frame(e, n, r, t, o) {
              return {
                block: e,
                tokenStart: n,
                tokenLength: r,
                prevOffset: t || n + r,
                leadingHtmlStart: o
              };
            }(Block(l, u, [], "", []), f, a, f + a, p)), t = f + a, !0;

          case "block-closer":
            if (0 === i) return addFreeform(), !1;
            if (1 === i) return addBlockFromStack(f), t = f + a, !0;

            var _e3 = s.pop(),
                _n = r.substr(_e3.prevOffset, f - _e3.prevOffset);

            return _e3.block.innerHTML += _n, _e3.block.innerContent.push(_n), _e3.prevOffset = f + a, addInnerBlock(_e3.block, _e3.tokenStart, _e3.tokenLength, f + a), t = f + a, !0;

          default:
            return addFreeform(), !1;
        }
      }

      function addFreeform(e) {
        var n = e || r.length - t;
        0 !== n && o.push(Freeform(r.substr(t, n)));
      }

      function addInnerBlock(e, n, t, o) {
        var c = s[s.length - 1];
        c.block.innerBlocks.push(e);
        var l = r.substr(c.prevOffset, n - c.prevOffset);
        l && (c.block.innerHTML += l, c.block.innerContent.push(l)), c.block.innerContent.push(null), c.prevOffset = o || n + t;
      }

      function addBlockFromStack(e) {
        var _s$pop = s.pop(),
            n = _s$pop.block,
            t = _s$pop.leadingHtmlStart,
            c = _s$pop.prevOffset,
            l = _s$pop.tokenStart,
            u = e ? r.substr(c, e - c) : r.substr(c);

        u && (n.innerHTML += u, n.innerContent.push(u)), null !== t && o.push(Freeform(r.substr(t, l - t))), o.push(n);
      }

      n.parse = function (e) {
        r = e, t = 0, o = [], s = [], c.lastIndex = 0;

        do {} while (proceed());

        return o;
      };
    }(), e;
  }();
});